import styled from "styled-components";

//Example: Using colors from theme
// background-color: ${({ theme }) => theme.colors.darkOrange};
export const Test = styled.div`
    display: flex;
    justify-content: center;
    align-items:center;
    height: 100vh;
    background-color: ${({ theme }) => theme.colors.white};
`